import React, { useMemo, useRef, useState, useCallback } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useLanguage } from '../../../contexts/LanguageContext';

const DealerStockReportTable = ({ rows = [], loading = false, filters, totalCount = 0, pagination = { PageNumber: 1, PageSize: 10 }, onPageChange = () => {}, onShowLogs = () => {}, columnsRef }) => {
    const { th } = useLanguage();
    const dataTableRef = useRef(null);

    const getColumnsCallback = useCallback(
        (el) => {
            if (el && el.getColumns && !columnsRef.current) columnsRef.current = el.getColumns();
            dataTableRef.current = el;
        },
        [columnsRef]
    );

    const [sortField, setSortField] = useState('partCode');
    const [sortOrder, setSortOrder] = useState(1);

    const normalized = useMemo(() => (Array.isArray(rows) ? rows : []), [rows]);

    const sorted = useMemo(() => {
        if (!sortField || sortOrder === 0) return normalized;
        const copy = [...normalized];
        return copy.sort((a, b) => {
            let av = a?.[sortField],
                bv = b?.[sortField];
            if (av == null && bv == null) return 0;
            if (av == null) return sortOrder;
            if (bv == null) return -sortOrder;
            if (typeof av === 'string') av = av.toLowerCase();
            if (typeof bv === 'string') bv = bv.toLowerCase();
            if (av < bv) return -sortOrder;
            if (av > bv) return sortOrder;
            return 0;
        });
    }, [normalized, sortField, sortOrder]);

    const handleSort = (e) => {
        setSortField(e.sortField);
        setSortOrder(e.sortOrder);
    };

    const actionBodyTemplate = (row) => <i className="pi pi-history cursor-pointer text-blue-500 hover:text-blue-700" title={th('dealerStockReport.history') || 'Geçmiş'} onClick={() => onShowLogs(row)} />;

    return (
        <DataTable
            key={`stock-table-${sorted.length}-${loading}-${sortField}-${sortOrder}`}
            value={sorted}
            dataKey="id"
            lazy
            paginator
            first={(pagination?.PageNumber - 1) * (pagination?.PageSize || 10)}
            rows={pagination?.PageSize || 10}
            totalRecords={totalCount}
            onPage={onPageChange}
            onSort={handleSort}
            sortField={sortField}
            sortOrder={sortOrder}
            loading={loading}
            filters={filters}
            filterDisplay="menu"
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
            tableStyle={{ minWidth: '60rem' }}
            showGridlines
            stripedRows
            sortMode="single"
            ref={getColumnsCallback}
            emptyMessage={th('dealerStockReport.empty') || 'Kayıt bulunamadı'}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate={th('table.paginatorTemplate')}
        >
            <Column body={actionBodyTemplate} exportable={false} style={{ width: '5%', minWidth: 33 }} />
            <Column field="partCode" header={th('dealerStockReport.partCode') || 'Parça Kodu'} sortable />
            <Column field="partDesc" header={th('dealerStockReport.partDesc') || 'Parça Açıklaması'} sortable />
            <Column field="uom" header={th('dealerStockReport.uom') || 'Birim'} sortable style={{ width: 100 }} />
            <Column field="quantity" header={th('dealerStockReport.quantity') || 'Miktar'} sortable style={{ width: 120 }} />
        </DataTable>
    );
};

export default DealerStockReportTable;
